import { api } from '@/shared/api/client';
import type { UserMeResponse } from '../model/dto';

export const getUsersMe = async () => {
  const { data } = await api.get<UserMeResponse>('/users/me/');
  return data;
};
